import { useState } from 'react';
import { Box, Button, Input, Modal } from '@nerdwallet/currency';
import { createTemplate } from '~/app/lib/redux/actions/builder';
import { useDispatch } from 'react-redux';

export function NewOfferIdModal({
  modalOpen,
  toggleOpen,
  nodeId,
}: {
  modalOpen: boolean;
  toggleOpen: () => void;
  nodeId: string;
}) {
  const [marketplaceProductId, setMarketplaceProductId] = useState('');
  const dispatch = useDispatch();
  const handleCreate = () => {
    toggleOpen();
    dispatch(createTemplate(nodeId, marketplaceProductId) as any);
  };
  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={toggleOpen}
      title="Create Marketplace Product"
      subtitle="Please enter the Marketplace Product ID"
    >
      <Box paddingY="2" width="100">
        <Input
          fullWidth
          label="Marketplace Product ID"
          name="marketplaceProductId"
          placeholder="Enter Marketplace Product ID"
          value={marketplaceProductId}
          onChange={(e) => setMarketplaceProductId(e.target.value)}
        />
      </Box>
      <Box
        paddingY="2"
        display="flex"
        width="100"
        alignItems="center"
        flexDirection="column"
      >
        <Button primary onClick={handleCreate}>
          Create
        </Button>
      </Box>
    </Modal>
  );
}
